/*! plata-script v9 */
(function () {
  "use strict";

  var loader = document.querySelector('script[data-plata-theme="plata"]');
  if (!loader || window.__plataInit) { return; }
  window.__plataInit = true;

  function attr(name, fallback) {
    var v = loader.getAttribute(name);
    return (v && String(v).trim()) || fallback || "";
  }

  function trimSlash(s) {
    return String(s || "").replace(/\/+$/, "");
  }

  var apiUrl = trimSlash(attr("data-plata-url"));
  var checkoutUrl = trimSlash(attr("data-checkout-domain"));
  var scriptMode = attr("data-plata-script", "ua");
  var shop = (window.Shopify && window.Shopify.shop) || "";
  var shopSlug = attr("data-plata-shop");

  if (!apiUrl && !checkoutUrl) { return; }

  var TRACKING_COOKIE = "plata_tracking";
  var BOUND_ATTR = "data-plata-bound";
  var TRACKING_KEYS = [
    "utm_campaign","utm_medium","utm_source","utm_content","utm_term","utm_id",
    "fbclid","ttclid","epik","ScCid","gclid"
  ];

  var CHECKOUT_FORM_SEL = [
    'form[action^="/cart"]:not([action^="/cart/"])',
    'form[action="/checkout"]',
    'form[action="/a/checkout"]'
  ].join(",");

  var CHECKOUT_BTN_SEL = [
    '[name="checkout"],[name="Checkout"]',
    '[class*="checkout-btn"],[class*="btn-checkout"]',
    '[class*="checkout-button"],[class*="button-checkout"]',
    '[class*="carthook_checkout"]',
    '[id*="checkout-button"],[id*="checkout-btn"]',
    '[href*="/checkout"][class*="action_button"]',
    '[data-checkout-button]'
  ].join(",");

  var CHECKOUT_LINK_SEL = 'a[href^="/checkout"],a[href*="/checkout"]';
  var BUYNOW_FORM_SEL = 'form[action^="/cart/add"][data-skip-cart="true"]';
  var DYNAMIC_BTN_SEL = [
    '[data-shopify="payment-button"] button',
    '[data-shopify="payment-button"] .shopify-payment-button__button'
  ].join(",");

  var inFlight = false;
  var prefetchedCart = null;
  var prefetchPromise = null;
  var prefetchedAt = 0;

  // A cart read at page load is stale the moment the buyer adds anything, and
  // a stale token means "Cart is empty" from the API. Re-read past this age.
  var CART_TTL_MS = 15000;
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;
  var CART_PAGE_RE = /\/cart\/?$/;
  var resetPromise = null;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }
  function nativeCheckout() {
    window.location.href = shopRoot() + "checkout";
  }

  function preconnectCheckout() {
    if (!checkoutUrl || !document.head) { return; }
    var origin;
    try { origin = new URL(checkoutUrl).origin; } catch (_) { origin = checkoutUrl; }
    if (document.querySelector('link[data-plata-preconnect]')) { return; }
    var link = document.createElement("link");
    link.rel = "preconnect";
    link.href = origin;
    link.crossOrigin = "anonymous";
    link.setAttribute("data-plata-preconnect", "1");
    document.head.appendChild(link);
    var dns = document.createElement("link");
    dns.rel = "dns-prefetch";
    dns.href = origin;
    document.head.appendChild(dns);
  }

  function fetchCart() {
    prefetchPromise = fetch(shopRoot() + "cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        prefetchedCart = cart;
        prefetchedAt = Date.now();
        return cart;
      });
    return prefetchPromise;
  }

  /** The cart as it is now — re-read once the cached copy could have moved. */
  function currentCart() {
    if (prefetchedCart && Date.now() - prefetchedAt < CART_TTL_MS) {
      return Promise.resolve(prefetchedCart);
    }
    return prefetchPromise && !prefetchedCart ? prefetchPromise : fetchCart();
  }

  function cachedCartToken() {
    if (prefetchedCart && Date.now() - prefetchedAt < CART_TTL_MS) {
      return prefetchedCart.token || "";
    }
    return "";
  }

  /**
   * Every theme adds to the cart through /cart/add.js and friends, so watching
   * those calls is what keeps the prepared link tied to the real cart.
   */
  function watchCartWrites() {
    function isCartWrite(url) {
      try { return CART_WRITE_RE.test(String(url || "")); } catch (_) { return false; }
    }
    try {
      var nativeFetch = window.fetch;
      if (typeof nativeFetch === "function") {
        window.fetch = function (input) {
          var url = "";
          try {
            url = typeof input === "string" ? input : (input && input.url) || "";
          } catch (_) {}
          var result = nativeFetch.apply(this, arguments);
          if (isCartWrite(url) && result && typeof result.then === "function") {
            result.then(
              function () { invalidateCartPrefetch(); },
              function () {}
            );
          }
          return result;
        };
      }
    } catch (_) {}
    try {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (_method, url) {
        try { this.__plataCartWrite = isCartWrite(url); } catch (_) {}
        return open.apply(this, arguments);
      };
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__plataCartWrite) {
          this.addEventListener("loadend", function () {
            invalidateCartPrefetch();
          });
        }
        return send.apply(this, arguments);
      };
    } catch (_) {}
  }

  function invalidateCartPrefetch() {
    prefetchedCart = null;
    prefetchPromise = null;
    prefetchedAt = 0;
  }

  function refreshStorefrontCartUi(cart) {
    if (!cart) { return; }
    var count = 0;
    try {
      if (typeof cart.item_count === "number") {
        count = cart.item_count;
      } else if (cart.items && cart.items.length) {
        count = cart.items.reduce(function (sum, item) {
          return sum + (item.quantity || 0);
        }, 0);
      }
    } catch (_) {}
    var selectors = [
      "[data-cart-count]",
      "[data-cart-item-count]",
      ".cart-count",
      ".cart-count-bubble",
      "#CartCount",
      ".cart-link__bubble"
    ];
    for (var i = 0; i < selectors.length; i++) {
      document.querySelectorAll(selectors[i]).forEach(function (el) {
        try {
          el.setAttribute("data-cart-count", String(count));
          el.setAttribute("data-cart-item-count", String(count));
          if (el.childElementCount === 0) {
            el.textContent = String(count);
          }
          el.classList.toggle("hide", count === 0);
          el.classList.toggle("hidden", count === 0);
        } catch (_) {}
      });
    }
    try {
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (_) {}
  }

  function refreshCartOnReturn() {
    invalidateCartPrefetch();
    fetchCart()
      .then(resetCompletedCart)
      .then(function (cart) { refreshStorefrontCartUi(cart); })
      .catch(function () {});
  }

  /** Plata marks the Shopify cart after an order; Shopify never closes it. */
  function cartNeedsReset(cart) {
    return !!(cart && cart.attributes && cart.attributes._plata_cleanup);
  }

  /**
   * After a Plata order, drop the cart cookie so Shopify issues a fresh cart
   * (new token), as it does after its own checkout. Leftover lines move over.
   * Resolves with the fresh cart, or the same one when no reset is needed or
   * it did not work — the server rolls the session over in that case.
   */
  function resetCompletedCart(cart) {
    if (!cartNeedsReset(cart)) { return Promise.resolve(cart); }
    if (resetPromise) { return resetPromise; }

    var carry = (cart.items || []).map(function (it) {
      var line = { id: it.variant_id, quantity: it.quantity };
      if (it.properties) { line.properties = it.properties; }
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
        line.selling_plan = it.selling_plan_allocation.selling_plan.id;
      }
      return line;
    });
    var oldToken = cart.token;

    // Only go on once the cookie is really gone: re-adding lines to a cart
    // we failed to drop would double them on every page load.
    var oldCookie;
    try {
      oldCookie = rawCookie("cart");
      if (!oldCookie) { return Promise.resolve(cart); }
      expireCookie("cart");
      if (getCookie("cart")) { return Promise.resolve(cart); }
    } catch (_) {
      return Promise.resolve(cart);
    }
    invalidateCartPrefetch();

    var root = shopRoot();
    var add = carry.length
      ? fetch(root + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: carry })
        }).catch(function (err) {
          // The lines never reached a new cart: bring the old one back.
          restoreCookie("cart", oldCookie);
          throw err;
        })
      : Promise.resolve();

    resetPromise = add
      .then(function () { return fetchCart(); })
      .then(function (fresh) {
        if (!fresh || !fresh.token || fresh.token === oldToken) { return cart; }
        refreshStorefrontCartUi(fresh);
        var path = "";
        try { path = window.location.pathname || ""; } catch (_) {}
        if (carry.length && CART_PAGE_RE.test(path)) {
          try { window.location.reload(); } catch (_) {}
        }
        return fresh;
      })
      .catch(function () { return cart; })
      .then(function (result) {
        resetPromise = null;
        return result;
      });
    return resetPromise;
  }

  function getCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) { return undefined; }
    return decodeURIComponent(parts.pop().split(";").shift() || "");
  }
  function rawCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) { return ""; }
    return parts.pop().split(";").shift() || "";
  }
  function restoreCookie(name, raw) {
    try {
      var exp = new Date(Date.now() + 14 * 864e5).toUTCString();
      document.cookie = name + "=" + raw + "; expires=" + exp + "; path=/";
    } catch (_) {}
  }
  function expireCookie(name) {
    var base = name + "=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    document.cookie = base;
    var host = "";
    try { host = window.location.hostname || ""; } catch (_) {}
    if (host) {
      document.cookie = base + "; domain=" + host;
      document.cookie = base + "; domain=." + host;
    }
  }
  function setCookieDays(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; expires=" + exp + "; path=/;";
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  var _gaCache = "";
  function getGaLinker() {
    if (_gaCache) { return _gaCache; }
    try {
      var gl = new URLSearchParams(window.location.search).get("_gl");
      if (gl) { _gaCache = "_gl=" + gl; return _gaCache; }
    } catch (_) {}
    try {
      if (typeof gtag !== "undefined" && Array.isArray(window.dataLayer)) {
        var hit = window.dataLayer.find(function (r) {
          return Array.isArray(r) && r[0] === "config" && typeof r[1] === "string" && r[1].startsWith("G-");
        });
        if (hit) {
          setTimeout(function () {
            try {
              gtag("get", hit[1], "linker_param", function (v) {
                if (v && v.indexOf("_gl=") !== -1) { _gaCache = v; }
              });
            } catch (_) {}
          }, 0);
        }
      }
    } catch (_) {}
    return "";
  }

  function saveTrackingParams() {
    var qs = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(getCookie(TRACKING_COOKIE) || "{}"); } catch (_) {}
    var clickKeys = { fbclid: 1, ttclid: 1, gclid: 1, epik: 1, ScCid: 1 };
    var hasClick = false;
    var hasAny = false;
    var saved = {};
    Object.keys(stored).forEach(function (k) { saved[k] = stored[k]; });
    TRACKING_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v) {
        saved[k] = v;
        hasAny = true;
        if (clickKeys[k]) { hasClick = true; }
      }
    });
    if (!hasAny) { return; }
    if (!hasClick && stored.fbclid && !qs.get("fbclid")) {
      saved.fbclid = stored.fbclid;
    }
    setCookieDays(TRACKING_COOKIE, JSON.stringify(saved), 7);
  }

  function buildAttribution() {
    var qs = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(getCookie(TRACKING_COOKIE) || "{}"); } catch (_) {}
    var get = function (k) { return qs.get(k) || stored[k] || ""; };
    var out = {};
    var fbp = getCookie("_fbp"); if (fbp) { out.fbp = fbp; }
    var fbc = getCookie("_fbc"); if (fbc) { out.fbc = fbc; }
    var fbclid = get("fbclid"); if (fbclid) { out.fbclid = fbclid; }
    ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","utm_id"].forEach(function (k) {
      var v = get(k);
      if (v) { out[k] = v; }
    });
    var lang = (navigator.languages && navigator.languages[0] || navigator.language || "").slice(0, 2);
    if (lang) { out.utm_lang = lang; out.locale = lang; }
    try { out.landingUrl = window.location.href; } catch (_) {}
    if (document.referrer) { out.referrer = document.referrer; }
    return out;
  }

  function attributionQuery() {
    try {
      var params = new URLSearchParams();
      var data = buildAttribution();
      Object.keys(data).forEach(function (k) {
        if (data[k]) { params.set(k, data[k]); }
      });
      return params.toString();
    } catch (_) {
      return "";
    }
  }

  function goLegacyStart(cartToken) {
    var dest = checkoutUrl
      ? checkoutUrl + "/c/start"
      : apiUrl + "/shopify/checkout";
    window.location.href =
      dest +
      "?shop=" + encodeURIComponent(shop) +
      "&cart=" + encodeURIComponent(cartToken);
  }

  function sendCartSnapshot(cart) {
    try {
      if (!(checkoutUrl && navigator.sendBeacon && cart)) { return; }
      navigator.sendBeacon(
        checkoutUrl + "/c/e/snapshot",
        new Blob(
          [JSON.stringify({
            slug: shopSlug,
            cartToken: cart.token,
            items: cart.items,
            subtotal: cart.items_subtotal_price,
            total: cart.total_price,
            currency: cart.currency,
            snapshottedAt: Date.now()
          })],
          { type: "text/plain" }
        )
      );
    } catch (_) {}
  }

  function goCheckout(cartToken, cart) {
    if (checkoutUrl && shopSlug && cartToken) {
      sendCartSnapshot(cart);
      var qs = attributionQuery();
      window.location.href =
        checkoutUrl +
        "/c/e/" +
        encodeURIComponent(shopSlug) +
        "/" +
        encodeURIComponent(cartToken) +
        (qs ? "?" + qs : "");
      return;
    }
    if (cartToken) {
      goLegacyStart(cartToken);
      return;
    }
    nativeCheckout();
  }

  function redirectWithCart(cart) {
    if (cart && cart.token && cart.items && cart.items.length) {
      goCheckout(cart.token, cart);
      return;
    }
    nativeCheckout();
  }

  function fetchCartAndRedirect() {
    return currentCart().then(resetCompletedCart).then(redirectWithCart);
  }

  function processCheckout(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (inFlight) { return; }
    var token = cachedCartToken();
    if (
      token &&
      prefetchedCart &&
      prefetchedCart.items &&
      prefetchedCart.items.length &&
      !cartNeedsReset(prefetchedCart)
    ) {
      goCheckout(token, prefetchedCart);
      return;
    }
    inFlight = true;
    fetchCartAndRedirect()
      .catch(function (err) {
        console.error("[plata]", err);
        nativeCheckout();
      })
      .finally(function () { inFlight = false; });
  }

  function submitBuyNow(el) {
    if (inFlight) { return; }
    var form =
      (el.closest && el.closest("form")) ||
      document.querySelector('form[action^="/cart/add"]');
    if (!form) { return; }
    if (!form.querySelector('[name="quantity"]')) {
      var qi = document.createElement("input");
      qi.type = "hidden";
      qi.name = "quantity";
      qi.value = "1";
      form.appendChild(qi);
    }
    inFlight = true;
    invalidateCartPrefetch();
    var root = shopRoot();
    fetch(root + "cart/clear.js", { method: "POST", credentials: "same-origin" })
      .then(function () {
        return fetch(root + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          body: new FormData(form)
        });
      })
      .then(function () { return fetchCartAndRedirect(); })
      .catch(function (err) {
        console.error("[plata]", err);
        nativeCheckout();
      })
      .finally(function () { inFlight = false; });
  }

  function wrapEl(el, events, handler) {
    if (el.getAttribute(BOUND_ATTR)) { return; }
    el.setAttribute(BOUND_ATTR, "1");
    events.forEach(function (ev) {
      window.addEventListener(
        ev,
        function (e) {
          if (e.target === el || el.contains(e.target)) {
            e.stopImmediatePropagation();
            e.preventDefault();
            handler(e);
          }
        },
        true
      );
    });
  }

  function bindAll() {
    document.querySelectorAll(CHECKOUT_FORM_SEL).forEach(function (el) {
      wrapEl(el, ["submit"], processCheckout);
    });
    document.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (el) {
      wrapEl(el, ["click"], processCheckout);
    });
    document.querySelectorAll(CHECKOUT_LINK_SEL).forEach(function (el) {
      wrapEl(el, ["click"], processCheckout);
    });
    document.querySelectorAll(BUYNOW_FORM_SEL).forEach(function (el) {
      wrapEl(el, ["submit"], function () { submitBuyNow(el); });
    });
    document.querySelectorAll(DYNAMIC_BTN_SEL).forEach(function (el) {
      wrapEl(el, ["click"], function () { submitBuyNow(el); });
    });
  }

  if (scriptMode === "ua" && !(window.Shopify && window.Shopify.country === "UA")) {
    return;
  }

  saveTrackingParams();
  preconnectCheckout();
  watchCartWrites();
  fetchCart().then(resetCompletedCart).catch(function () {});
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function () {}
      );
    }
  } catch (_) {}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAll);
  } else {
    bindAll();
  }

  window.addEventListener("load", function () {
    bindAll();
    var debouncedBind = debounce(bindAll, 400);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          debouncedBind();
          break;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  });

  document.addEventListener("shopify:section:load", bindAll);
  document.addEventListener("shopify:payment_button:loaded", bindAll);

  window.addEventListener("pageshow", function (e) {
    inFlight = false;
    bindAll();
    if (e.persisted) { refreshCartOnReturn(); }
  });
  window.addEventListener("focus", function () { if (inFlight) { inFlight = false; } });
  window.addEventListener("popstate", function () { inFlight = false; });
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      if (inFlight) { inFlight = false; }
      refreshCartOnReturn();
    }
  });
})();
